import React from "react"
import MetaTags from "react-meta-tags"
import { Container, Row, Col } from "reactstrap"
import { Redirect } from "react-router-dom"
import MetaWhatsappConnect from "../../components/Admin/profileComps/metaWhatsappConnect"
import { isMetaWhatsappEnabled } from "../../helpers/Utils"

const ConnectWhatsappMeta = () => {
  const enabled = isMetaWhatsappEnabled()

  if (!enabled) {
    return <Redirect to="/settings" />
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>WhatsApp Business | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box pb-2">
            <Row className="align-items-center g-2">
              <Col lg={4} md={5}>
                <h4 className="page-title mb-1">WhatsApp Business</h4>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">Settings</li>
                  <li className="breadcrumb-item active">WhatsApp Business</li>
                </ol>
              </Col>
              <Col lg={8} md={7} className="text-md-end">
                {/* Action buttons render here via portal from MetaWhatsappConnect */}
                <div
                  id="meta-wa-connect-actions"
                  className="d-inline-flex flex-wrap gap-2 justify-content-md-end"
                />
              </Col>
            </Row>
          </div>
          <MetaWhatsappConnect />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ConnectWhatsappMeta
